/**
 * Labstep
 *
 * @module screens/Resource/Show
 * @desc Resource Show Screen
 */

import { DocumentHead } from 'labstep-web/core/DocumentHead';
import { Redirect } from 'labstep-web/core/Redirect';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import MasterShow from 'labstep-web/screens/Master/Show';
import { ResourceShowCenter as Center } from 'labstep-web/screens/Resource/Show/Center';
import { ScreensResourceShowRight as Right } from 'labstep-web/screens/Resource/Show/Right';
import type React from 'react';
import type {
  IResourceShowScreenContainerProps,
  IResourceShowScreenProps,
} from './types';

export const ResourceShowScreen: React.FC<
  IResourceShowScreenProps
> = ({ resource }) => (
  <>
    <DocumentHead title={resource.name || ''} />
    <MasterShow
      entity={resource}
      center={<Center resource={resource} />}
      right={<Right resource={resource} />}
    />
  </>
);

export const ResourceShowScreenContainer: React.FC<
  IResourceShowScreenContainerProps
> = ({ match }) => (
  <ReadOnMountHOC
    type="entities"
    entityName="resource"
    params={{
      get_single: 1,
      is_deleted: 'both',
      id: match.params.id,
    }}
    loading={{ loader: 'show', cached: true }}
    children={({ entity }) =>
      entity.is_template ? (
        <Redirect
          to="resource_template_show"
          params={{ id: entity.id }}
        />
      ) : (
        <ResourceShowScreen resource={entity} />
      )
    }
  />
);
